// extracted by mini-css-extract-plugin
module.exports = {"root":"Expansion_root__3yBEs","inset":"Expansion_inset__1s0Xz"};